<div
    class="mt-main-table flex-col"
    [ngClass]="{
        'disable-background': extraParams && extraParams.disableBackground
    }"
    *ngIf="tableDataset"
>
    <ng-container *ngIf="tableDataset && tableDataset.length; else noData">
        <ng-container *ngIf="!extraParams?.extraWide; else extraWide">
            <ng-container *ngTemplateOutlet="table"></ng-container>
            <ng-container *ngTemplateOutlet="tableFooter"></ng-container>
        </ng-container>
        <ng-template #extraWide>
            <div class="scroll-container">
                <div class="scroll-data">
                    <ng-container *ngTemplateOutlet="table"></ng-container>
                </div>
            </div>
            <ng-container *ngTemplateOutlet="tableFooter"></ng-container>
        </ng-template>
    </ng-container>

    <ng-template #noData>
        <div
            *ngIf="extraParams && extraParams.noDataMsg"
            class="mt-main-table-no-data"
        >
            {{ extraParams.noDataMsg | lang : extraParams?.noDataMsgParam }}
        </div>

        <div
            *ngIf="!extraParams || !extraParams.noDataMsg"
            class="mt-main-table-no-data"
        >
            {{ "m021" | lang }}
        </div>
    </ng-template>

    <ng-template #table>
        <app-header-table
            [headers]="tableHeaders"
            [thickness]="extraParams?.rowThickness"
            (sortCall)="sortByKey($event)"
        ></app-header-table>
        <app-data-table
            [dataset]="tableDataset"
            [dataSort]="dataSort"
            [quantity]="quantityPerPage"
            [pagination]="currentPage"
            [tableExtraParams]="extraParams"
            class="data-table"
            (sendRowInfo)="sendInfoToComponent.emit($event)"
        >
        </app-data-table>
    </ng-template>

    <ng-template #tableFooter>
        <div
            class="flex-row mt-table-footer"
            [ngStyle]="{
                display:
                    extraParams && extraParams.disableFooter ? 'none' : null
            }"
        >
            <app-register-per-page
                [quantity]="tableDataset.length ? tableDataset.length : 1"
                [quantityPerPage]="quantityPerPage"
                (changeQuantity)="changeQuantity($event)"
            ></app-register-per-page>
            <div class="col"></div>
            <app-paginator
                (pageChanged)="changePage($event)"
                [pagination]="pagination"
            ></app-paginator>
        </div>
    </ng-template>
</div>
